import { call, put, takeLatest } from "redux-saga/effects";
import { Action } from "../../../actions/actions";
import { API } from "../../../api/api";
import { ConfigurationsActionTypes } from "../actions/actionTypes";
import { configurationsAPI } from "../api/api";

function* getMegapotProvidersList(action: Action) {
    try {
        const response = yield call(() =>
            configurationsAPI.getMegapotProvidersList()
        );

        yield put({
            type: ConfigurationsActionTypes.GET_MEGAPOT_PROVIDERS_LIST_SUCCESS,
            payload: response.data
        });
    } catch (e) {
        API.handleError(e.response, "Error getting megapot providers list.");

        yield put({
            type: ConfigurationsActionTypes.GET_MEGAPOT_PROVIDERS_LIST_FAIL,
            payload: e
        });
    }
}

export function* getMegapotProvidersListWatcher() {
    yield takeLatest(ConfigurationsActionTypes.GET_MEGAPOT_PROVIDERS_LIST, getMegapotProvidersList);
}
